var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "prodinfo--card" },
        [
          _c("z-search", {
            ref: "search",
            attrs: { configs: _vm.configs, showNumCheck: false },
            on: { "do-query": _vm.query },
            model: {
              value: _vm.searchData,
              callback: function ($$v) {
                _vm.searchData = $$v
              },
              expression: "searchData",
            },
          }),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c("div", { staticClass: "prodstock--list__total" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("storage::commodity-stocks:total_stock")) +
                "： " +
                _vm._s(_vm.allStock) +
                " "
            ),
            _c("span", { staticStyle: { "margin-left": "5px" } }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("storage::commodity-stocks:total_stock_amount")
                  ) +
                  "： ￥" +
                  _vm._s(_vm.allValuation) +
                  " "
              ),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tableSelections.length,
                  expression: "tableSelections.length",
                },
              ],
              staticClass: "prodstock--list__tips",
            },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::commodity-stocks::selected")) +
                    " " +
                    _vm._s(_vm.tableSelections.length) +
                    " " +
                    _vm._s(_vm.$t("storage::commodity-stocks::item")) +
                    " "
                ),
              ]),
              _vm._v(" | "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "storage::commodity-stocks::platform_table_use_stock"
                    )
                  ) +
                    "：" +
                    _vm._s(_vm.totalAvailableInventory || 0)
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "storage::commodity-stocks::platform_table_commodity_stock"
                    )
                  ) +
                    "：" +
                    _vm._s(_vm.totalProductStock || 0)
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("storage::commodity-stocks::platform_total_stock")
                  ) +
                    "：" +
                    _vm._s(_vm.totalvaluation || 0)
                ),
              ]),
            ]
          ),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "prodstock--table",
            attrs: {
              columns: _vm.tableColumns,
              data: _vm.tableData,
              "max-height": 550,
              pagination: _vm.pagination,
            },
            on: {
              "selection-change": _vm.handleSelectTable,
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.handlePageChange,
            },
            scopedSlots: _vm._u([
              {
                key: "sku",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "100%", cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.showInventoryList(row)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "prodstock--table__imgTd",
                            staticStyle: { "line-height": "0" },
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("ZImg", {
                                  staticStyle: {
                                    width: "250px",
                                    height: "250px",
                                  },
                                  attrs: { src: row.imageUrl },
                                }),
                                _c("ZImg", {
                                  staticStyle: {
                                    width: "64px",
                                    height: "64px",
                                  },
                                  attrs: {
                                    slot: "reference",
                                    src: row.imageUrl,
                                  },
                                  slot: "reference",
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "prodstock--table__name" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.productName
                                            ? row.productName + "-"
                                            : ""
                                        ) +
                                        _vm._s(row.optionValueNames) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "prodstock--table__spu" },
                                  [
                                    _vm._v(
                                      " SPU: " +
                                        _vm._s(row.spu) +
                                        _vm._s(
                                          row.productCategory
                                            ? " | " + row.productCategory
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "prodstock--table__sku" },
                                  [_vm._v("SKU: " + _vm._s(row.sku))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "supplyCost",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.supplyCost
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$dataCheck(row.supplyCost, "--"))),
                        ])
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
              {
                key: "supplyCostHeader",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "storage::commodity-stocks::platform_table_pat_cost"
                              )
                            ) +
                            " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top-start" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "storage::commodity-stocks::platform_table_pat_cost_tips1"
                                      )
                                    ) +
                                    "， "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "storage::commodity-stocks::platform_table_pat_cost_tips2"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("i", {
                              staticClass: "icon-a-01wenhao iconfont-el",
                              staticStyle: { "font-size": "14px" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "valuationStockHeader",
                fn: function () {
                  return [
                    _c(
                      "div",
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "storage::commodity-stocks::platform_table_stock_amount"
                              )
                            ) +
                            " "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top-start" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "storage::commodity-stocks::platform_table_stock_equal"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("i", {
                              staticClass: "icon-a-01wenhao iconfont-el",
                              staticStyle: { "font-size": "14px" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "stock",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "storage::commodity-stocks::platform_table_use_stock"
                            )
                          ) +
                          ": " +
                          _vm._s(_vm.$dataCheck(row.usedStock, "--")) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "storage::commodity-stocks::platform_table_commodity_stock"
                            )
                          ) +
                          ": "
                      ),
                      _c(
                        "span",
                        {
                          style:
                            "color:" +
                            _vm.compareCount(row.productStock, row.safeStock),
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$dataCheck(row.productStock, "--")) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "storage::commodity-stocks::platform_table_safe_stock"
                            )
                          ) +
                          ": " +
                          _vm._s(_vm.$dataCheck(row.safeStock, "--")) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "valuationStock",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$dataCheck(row.valuationStock, "--"))),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("stockFlow", {
        attrs: { sku: _vm.selectSku },
        on: { closeDialog: _vm.closeDialog },
        model: {
          value: _vm.isShowStockFlow,
          callback: function ($$v) {
            _vm.isShowStockFlow = $$v
          },
          expression: "isShowStockFlow",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }